import React, { useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { message } from 'antd';
import { withRouter } from 'react-router-dom';
import { checkPowerCreateActivity } from '@/common/utils/helper';
import { connect } from 'react-redux';
// import CreateActivityModal from '@/components/create-activity-modal';
import envProd from '@/env/env.prod';
import goTo from '@/common/goto';
import Empty from '@/components/core-empty';

function ReportEmpty(props) {
  // const noPowerMessage = () => {
  //   message.info({
  //     content: (
  //       <a
  //         target="_blank"
  //         without
  //         rel="noopener noreferrer"
  //         href={`${envProd.ACORE_DOMAIN}/notice/65`}
  //         style={{ color: '#fff' }}
  //       >
  //         暂无权限，点击申请
  //       </a>
  //     ),
  //   });
  // };
  // const [visible, setVisible] = useState(false);

  // const toCreate = (type) => {
  //   switch (type) {
  //     case 'tradition':
  //       goTo.promotionActivityCreate().push();
  //       break;
  //     case 'merchant':
  //       goTo.merchantActivityCreate().push();
  //       break;
  //   }
  // };

  return (
    <div className="report-process-empty">
      <Empty />
      {/* <div
        className="report-process-create"
        // onClick={toCreate}
        onClick={() => props.checkPowerCreateActivity(() => setVisible(true), noPowerMessage)}
      >
        <PlusOutlined style={{ padding: '0 5px 0 10px' }} />
        创建活动
      </div> */}
      {/* <CreateActivityModal
        visible={visible}
        toClose={() => setVisible(false)}
        toCreateTraditionAct={() => toCreate('tradition')}
        toCreateMerchantsAct={() => toCreate('merchant')}
      /> */}
    </div>
  );
}

export default withRouter(
  connect((state) => {
    return {
      checkPowerCreateActivity(resolve, reject) {
        return checkPowerCreateActivity(state.userInfo, resolve, reject);
      },
    };
  })(ReportEmpty)
);
